module.exports = __webpack_public_path__ + "img/GG.218797b3.svg";